module.exports = __webpack_public_path__ + "img/QR_sc.12ec1f99.jpg";